import React from "react";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import Title from "./title";
import Name from "./name";

export default function NamesPanel(props) {
  const { names, translate } = props;

  // Returns true if it's the last element of the array
  const isLast = (index, arr) => {
    return index !== arr.length - 1;
  };

  return (
    <>
      <Box display="flex" alignItems="center" paddingLeft={2.75} marginTop={3}>
        <Title text={translate("GLOSSARY.names")} />
      </Box>
      <Box
        marginTop={0.75}
        paddingLeft={2.75}
        paddingRight={2.75}
        color="#2B292D"
        lineHeight="2"
      >
        {names.length !== 0 &&
          names.map((name, index, arr) => (
            <Box
              key={`name-${index}`}
              display="inline-flex"
              fontSize={{ xs: 10, sm: 12, md: 12, lg: 14, xl: 14 }}
            >
              <Name name={name} />

              {/* Comma after each element except last one */}
              {isLast(index, arr) && <>,&nbsp;</>}
            </Box>
          ))}
      </Box>
    </>
  );
}

NamesPanel.propTypes = {
  names: PropTypes.arrayOf(PropTypes.string).isRequired,
  translate: PropTypes.func.isRequired,
};
